module.exports = __webpack_public_path__ + "c41486347d1ccfcef233c67dc8d8ca80.jpg";